import React from "react";
import GoogleMap from "./google_map";

const Location = () => {
  const lat = 49.49502;
  const long = 5.98557;
  const marker = {
    position: {
      lat: lat,
      lng: long,
    },
    key: `Dr. Weyrich`,
    defaultAnimation: 2,
  };
  return (
    <section className="location">
      <h2 className="text-uppercase">
        <i className="fa fa-lg fa-map"></i> Location
      </h2>
      <div className="map">
        <GoogleMap lat={lat} long={long} marker={marker} />
      </div>
    </section>
  );
};

export default Location;



// WEBPACK FOOTER //
// ./src/components/Location.js